// Identity lives in an httpOnly session cookie that JavaScript cannot read,
// so the client asks the server who it is rather than asserting it.

export const fetchUser = async () => {
  try {
    const res = await fetch("/api/me");
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
};

export const logout = async () => {
  try {
    await fetch("/api/logout", { method: "POST" });
  } catch {
    // Nothing useful to do; the cookie expires on its own.
  }
};
